import {type ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {RotateCcw} from 'lucide-react';
import {Button, cn} from '@chekinapp/ui';

export type OverlayRetryButtonProps = {
  onClick: () => void;
  label?: ReactNode;
  icon?: ReactNode;
  className?: string;
};

export function OverlayRetryButton({
  onClick,
  label,
  icon,
  className,
}: OverlayRetryButtonProps) {
  const {t} = useTranslation('identity-verification');

  return (
    <Button
      onClick={onClick}
      className={cn('h-11 gap-2 whitespace-nowrap px-5 text-[14px]', className)}
    >
      {icon ?? <RotateCcw className="h-[18px] w-[18px] flex-none" />}
      {label ?? t('try_again')}
    </Button>
  );
}
